import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";

import Checkbox from "@client/components/ui/Checkbox";
import StatusPill from "@client/components/ui/StatusPill";
import Style from "@client/utils/Style";
import { ListItemColumn } from "@typings/List";

const CheckboxStyled = styled(Checkbox)`
  opacity: ${
    // $FlowIssue
    (props: any) => (props.checked ? 1 : 0)
  };
  transition: all ${Style.animations.swift};
`;
const Content = styled.div`
  display: flex;
  align-items: center;
  border-top: 1px solid ${Style.palette.grayscale[1]};
  padding: 8px 16px;
  cursor: pointer;
  flex-grow: 1;
  transition: all ${Style.animations.swift};
  min-width: 785px;

  &:hover {
    background: ${Style.palette.grayscale[1]};
  }
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  &:hover
    ${
      // $FlowIssue
      CheckboxStyled
    } {
    opacity: 1;
  }
  &:last-child ${Content} {
    border-bottom: 1px solid ${Style.palette.grayscale[1]};
  }
`;
const Image = styled.div<{ image: string }>`
  min-width: 48px;
  height: 48px;
  background: url("${(props: any) => props.image}") no-repeat center;
  margin-right: 16px;
  background-size: contain;
`;
const Title = styled.div`
  flex-grow: 1;
  overflow: hidden;
  margin-right: 48px;
  min-width: 100px;
`;
const TitleLabel = styled.div`
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const Subtitle = styled.div`
  color: ${Style.palette.grayscale[4]};
  margin-top: 3px;
`;
const StatusWrapper = styled.div`
  display: flex;
  margin-top: 4px;
`;
const Columns = styled.div`
  display: flex;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 16px;
`;
const ColumnName = styled.div`
  color: ${Style.palette.grayscale[4]};
`;
const ColumnValue = styled.div`
  color: ${Style.palette.primary};
  text-overflow: ellipsis;
  overflow: hidden;
`;

type Props = {
  title: string;
  subtitle?: string | null;
  onClick: () => void;
  selected: boolean;
  image: string;
  selectionEnabled: boolean | null;
  onSelectedChange: (value: boolean) => void;
  pillLabel?: string;
  pillBackgroundColor?: string;
  pillFontColor?: string;
  pillBorderColor?: string;
  extraPills?:
    | {
        label: string;
        backgroundColor?: string;
        fontColor?: string;
        borderColor?: string;
      }[]
    | null;
  columns: ListItemColumn[];
};
@observer
class FilterListItem extends React.Component<Props> {
  render() {
    return (
      <Wrapper>
        {this.props.selectionEnabled ? (
          <CheckboxStyled
            checked={this.props.selected}
            onChange={this.props.onSelectedChange}
          />
        ) : null}
        <Content
          onClick={this.props.onClick}
          style={{ marginLeft: this.props.selectionEnabled ? "16px" : 0 }}
        >
          <Image image={this.props.image} />
          <Title>
            <TitleLabel>{this.props.title}</TitleLabel>
            {this.props.subtitle ? (
              <Subtitle>{this.props.subtitle}</Subtitle>
            ) : null}
            <StatusWrapper>
              {this.props.pillLabel ? (
                <StatusPill
                  label={this.props.pillLabel}
                  backgroundColor={this.props.pillBackgroundColor}
                  fontColor={this.props.pillFontColor}
                  borderColor={this.props.pillBorderColor}
                  style={{ marginRight: "8px" }}
                />
              ) : null}
              {this.props.extraPills?.map(pill => (
                <StatusPill
                  key={pill.label}
                  label={pill.label}
                  backgroundColor={pill.backgroundColor}
                  fontColor={pill.fontColor}
                  borderColor={pill.borderColor}
                  style={{ marginRight: "8px" }}
                />
              ))}
            </StatusWrapper>
          </Title>
          <Columns>
            {this.props.columns.map(column => (
              <Column style={column.style} key={column.name}>
                <ColumnName>{column.name}</ColumnName>
                <ColumnValue>{column.value}</ColumnValue>
              </Column>
            ))}
          </Columns>
        </Content>
      </Wrapper>
    );
  }
}

export default FilterListItem;
